import { observer } from 'mobx-react-lite'
import { lazy, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { ArrowLeftOutlined } from '@ant-design/icons'

import { useStore } from 'store/useStore'
import { ContainerLK } from 'sections/LKSection/shared/components/ContainerLK/ContainerLK'
import { Margin, Padding } from 'components/ui'
import { Container } from 'components/ui/Container/Container'
import { Href } from 'components/ui/Href/Href'
import { Button, Flex, Steps, Title } from 'components/uiKit'
import { LKRoutesEnum } from 'shared/constants/routes'

import { OrderKeys } from '../../data'
import { FilesUploadingStep } from './Steps/FilesUploadingStep/FilesUploadingStep'
import { LocationStep } from './Steps/LocationStep/LocationStep'
import { RequirementsStep } from './Steps/RequirementsStep/RequirementsStep'
import { WorkConditionsStep } from './Steps/WorkConditionsStep/WorkConditionsStep'

const stepTitles = [
  {
    title: 'Требования',
  },
  {
    title: 'Расположение',
  },
  {
    title: 'Условия работы',
  },
  {
    title: 'Загрузка файлов',
  },
]

const steps: Map<number, JSX.Element> = new Map([
  [1, <RequirementsStep key={1} />],
  [2, <LocationStep key={2} />],
  [3, <WorkConditionsStep key={3} />],
  [4, <FilesUploadingStep key={4} />],
])

const getKey = (key: string) => `${OrderKeys.createOrderPage}.${key}`

const CreateOrderPage = observer(() => {
  const { createOrderUiStore: uiStore, viewPvzUiStore } = useStore()

  const location = useLocation()
  const { t } = useTranslation()

  const queryParams = new URLSearchParams(location.search)
  const exPvzId = queryParams.get('pvzId')

  const items = stepTitles.map((item) => ({ key: item.title, title: t(getKey(item.title)) }))

  useEffect(() => {
    if (exPvzId) {
      const pvzItem = viewPvzUiStore.getPvz(+exPvzId)

      if (pvzItem?.externalId) {
        uiStore.setExPickPointId(pvzItem.externalId)
      }
    }
  }, [uiStore, exPvzId, viewPvzUiStore])

  useEffect(() => {
    document.getElementById('routeScrollId')?.scrollTo(0, 0)
  }, [uiStore.selectedStep])

  useEffect(() => {
    return () => {
      uiStore.setExPickPointId(null)
    }
  }, [])

  return (
    <ContainerLK disableMaxWidth={uiStore.selectedStep === 2}>
      <Padding py={32}>
        <Margin mb={32}>
          <Flex gap={16} align="center">
            <Href href={LKRoutesEnum.orders}>
              <Button shape="circle" icon={<ArrowLeftOutlined />} />
            </Href>

            <Title>{t(getKey('Создание заявки'))}</Title>
          </Flex>
        </Margin>

        <Margin mb={16}>
          <Container>
            <Steps current={uiStore.selectedStep - 1} items={items} />
          </Container>
        </Margin>

        <Flex vertical gap={60}>
          {steps.get(uiStore.selectedStep)}
        </Flex>
      </Padding>
    </ContainerLK>
  )
})

export default CreateOrderPage

export const CreateOrderPageAsync = lazy(() => import('./CreateOrderPage'))
